import { createSlice, createAction } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  apiError: false,
};

const AccessorySlice = createSlice({
  name: "Accessories",
  initialState,
  reducers: {
    resetAccessorySlice: (state, action) => {
      return initialState;
    },
    setPageLoading: (state, action) => {
      state["loading"] = action.payload;
    },
    setAPIError: (state, action) => {
      state["apiError"] = action.payload;
    },
    setMetaInfo: (state, action) => {
      state["metaInformation"] = action.payload;
    },
    setCombinePricingInfo: (state, action) => {
      state["combinepricing"] = action.payload;
    },
    setAccessories: (state, action) => {
      state["accessories"] = action.payload;
    },
    setAddToCartResponse: (state, action) => {
      state["addToCartResponse"] = action.payload;
    },
    setAccessoryList: (state, action) => {
      state["accessoryList"] = action.payload;
    },
    setAccessoryDetails: (state, action) => {
      state["accessoryDetails"] = action.payload;
    },
    setSelectedAccessory:(state, action) => {
      state["selectedAccessory"] = action.payload;
    },
    setSelectedAccessorySku:(state, action) => {
      state["selectedAccessorySku"] = action.payload;
    },
    setGetReviewsResponse: (state, action) => {
      state["accessoryReviews"] = action.payload;
    },
    setAccessoryDeviceId: (state, action) => {
      state["accessoryDeviceId"] = action.payload;
    },
    setAddToCartNotification: (state, action) => {
      state["addToCartNotification"] = action.payload;
    },
    setAccessoryFilterSelected: (state,action) => {
      state["accessoryFilterApplied"] = action.payload;
    },
    setSelectedCompatibleType: (state,action) => {
      state["accessorySelectedCompatibleType"] = action.payload
    }
  },
});

export const reducer = AccessorySlice.reducer;
export const getMetaInformation = createAction(
  "AccessorySlice/getMetaInformation"
);
export const getInitPageLoadInfo = createAction(
  "AccessorySlice/getInitPageLoadInfo"
);
export const getCombinePricingInfo = createAction(
  "AccessorySlice/getCombinePricingInfo"
);
export const getAccessories = createAction("AccessorySlice/getAccessories");
export const getAccessoryList = createAction("AccessorySlice/getAccessoryList");
export const getAccessoryDetailPageInfo = createAction(
  "AccessorySlice/getAccessoryDetailPageInfo"
);
export const getAccessoryReview = createAction(
  "AccessorySlice/getAccessoryReview"
);
export const accessoryGridwallAddToCart = createAction(
  "AccessorySlice/accessoryGridwallAddToCart"
);

export const setAccessories = createAction(
  "AccessorySlice/setAccessories"
);

export const {
  resetAccessorySlice,
  setPageLoading,
  setAPIError,
  setMetaInfo,
  setCombinePricingInfo,
  // setAccessories,
  setAddToCartResponse,
  setAccessoryList,
  setAccessoryDetails,
  setSelectedAccessory,
  setSelectedAccessorySku,
  setGetReviewsResponse,
  setAccessoryDeviceId,
  setAddToCartNotification,
  setAccessoryFilterSelected,
  setSelectedCompatibleType
} = AccessorySlice.actions;
